// src/components/HeroBackground.jsx
import { useRive, Layout, Fit, Alignment } from "@rive-app/react-canvas";

function HeroBackground({ children, backgroundColor }) {
  const { RiveComponent } = useRive({
    src: "/animations/obz-bg-1.riv", // Ensure this path is correct
    autoplay: true,
    layout: new Layout({
      fit: Fit.Cover,
      alignment: Alignment.Center,
    }),
  });

  return (
    <div
      className={`flex flex-col relative w-full overflow-hidden ${
        backgroundColor === ""
          ? "min-h-[508px] md:min-h-[712px]"
          : "hidden md:block min-h-[880px]"
      }`}
    >
      {/* Background Rive animation */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <RiveComponent className="w-full h-full" />
      </div>

      {/* Foreground content */}
      <div className="z-10">{children}</div>
    </div>
  );
}

export default HeroBackground;
